// eslint-disable-next-line jira/import/no-wildcard-imports
import * as boardView from './board-view.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as collections from './collections.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as copyProjectConfiguration from './copy-project-configuration.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as deliveryItems from './delivery-items.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as fieldsSidebar from './fields-sidebar.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as formulaField from './formula-field.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as globalFieldsAdministration from './global-fields-administration.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as headerView from './header-view.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as ideaViewBentoSidebar from './idea-view-bento-sidebar.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as ideaView from './idea-view.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as issues from './issues.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as listView from './list-view.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as matrixView from './matrix-view.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as navBar from './nav-bar.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as noViewsScreen from './no-views-screen.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as playSidepanel from './play-sidepanel.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as project from './project.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as sharing from './sharing.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as timelineView from './timeline-view.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as viewPermissions from './view-permissions.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as view from './view.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as connections from './connections.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as issueTypes from './issue-types.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as projectTemplateCreationAsync from './project-template-creation-async.tsx';
// eslint-disable-next-line jira/import/no-wildcard-imports
import * as notification from './notification-settings.tsx';

export const experience = {
	listView,
	formulaField,
	headerView,
	boardView,
	ideaView,
	ideaViewBentoSidebar,
	matrixView,
	navBar,
	project,
	timelineView,
	fieldsSidebar,
	issues,
	deliveryItems,
	sharing,
	globalFieldsAdministration,
	playSidepanel,
	noViewsScreen,
	view,
	viewPermissions,
	collections,
	copyProjectConfiguration,
	connections,
	issueTypes,
	projectTemplateCreationAsync,
	notification,
};
